import MegaphoneIcon from "@uui/Announcement03";

import { isFreePlan } from "@app/analytics/account/Billing/utils";
import useBillingContext from "@app/analytics/hooks/billing/useBillingContext";
import useUserSettings from "@app/analytics/hooks/settings/useUserSettings";
import ROUTES from "@app/common/routes";

import Button from "@rui/Button";
import {
  EmptyStateContainer,
  EmptyStateIcon,
  EmptyStateSubtext,
  EmptyStateSubtextLink,
  EmptyStateTitle,
} from "@rui/EmptyStateContainer";
import Link from "@rui/Link";
import Stack from "@rui/Stack";

const UpsellPaid = () => (
  <>
    <EmptyStateSubtext>
      Coaching is only available for premium reports.{" "}
      <EmptyStateSubtextLink href={ROUTES.UPGRADE_ACCOUNT}>
        Upgrade your plan
      </EmptyStateSubtextLink>{" "}
      to unlock premium features for all your meetings.
    </EmptyStateSubtext>
    <Link href={ROUTES.UPGRADE_ACCOUNT}>
      <Button variant="gradient">Upgrade plan</Button>
    </Link>
  </>
);

const UpsellRecording = () => (
  <>
    <EmptyStateSubtext>
      Coaching is only available for premium reports.{" "}
      <EmptyStateSubtextLink to={ROUTES.USER_SETTINGS_RECORDING_AND_PLAYBACK}>
        Enable automatic recording
      </EmptyStateSubtextLink>{" "}
      to unlock coaching and other premium features for your next meeting.
    </EmptyStateSubtext>
    <Link to={ROUTES.USER_SETTINGS_RECORDING_AND_PLAYBACK}>
      <Button variant="gradient">Enable recording</Button>
    </Link>
  </>
);

const DefaultRestrictedTier = () => (
  <EmptyStateSubtext>
    Coaching is only available for premium reports.
  </EmptyStateSubtext>
);

const RestrictedTier = () => {
  const { currentPlan } = useBillingContext();
  const { userSettings } = useUserSettings();

  if (isFreePlan(currentPlan.type)) {
    return <UpsellPaid />;
  }

  if (userSettings.automaticRecordingEnabled) return <DefaultRestrictedTier />;

  return <UpsellRecording />;
};

const InvalidParticipant = () => (
  <EmptyStateSubtext>
    Coaching is only available to meeting participants, and Read could not
    detect your presence in this meeting.
  </EmptyStateSubtext>
);

const NoData = () => (
  <EmptyStateSubtext>
    Coaching cannot be generated for this meeting.
  </EmptyStateSubtext>
);

const CONTENT_BY_TYPE = {
  invalid_participant: <InvalidParticipant />,
  no_data: <NoData />,
  restricted_tier: <RestrictedTier />,
};

const EmptyCoachingContent = ({
  type,
}: {
  type: "invalid_participant" | "no_data" | "restricted_tier";
}) => {
  const content = CONTENT_BY_TYPE[type];
  return (
    <Stack padding={2} flex={1}>
      <EmptyStateContainer>
        <EmptyStateIcon Icon={MegaphoneIcon} />
        <EmptyStateTitle>No coaching available</EmptyStateTitle>
        {content}
      </EmptyStateContainer>
    </Stack>
  );
};

export default EmptyCoachingContent;
